import type { ThemeDirection } from './types.js';

export interface ThemeWordmark {
  family: string;
  weight: number;
  size: number;
  transform?: 'uppercase';
  tracking?: string;
}

export interface ThemeDef {
  tokens: Record<string, string>;
  wordmark: ThemeWordmark;
}

export const CONDUCTOR_THEMES: Record<ThemeDirection, ThemeDef> = {
  signal: {
    tokens: {
      '--bg': '#0B0E14',
      '--surface': '#10141D',
      '--surface2': '#151B26',
      '--border': '#1E2633',
      '--border2': '#2A3444',
      '--text': '#E6EDF3',
      '--muted': '#9AA7B8',
      '--faint': '#5B6B7E',
      '--accent': '#4ADE80',
      '--ok': '#4ADE80',
      '--run': '#7DD3FC',
      '--bad': '#F87171',
      '--warn': '#FBBF24',
      '--ok-bg': '#0F1A14',
      '--run-bg': '#0E1620',
      '--bad-bg': '#1A0F10',
      '--warn-bg': '#1C160A',
      '--radius': '10px',
      '--radius-sm': '8px',
      '--btn-radius': '8px',
      '--font-body': "'Space Grotesk', sans-serif",
      '--font-mono': "'JetBrains Mono', monospace",
      '--font-heading': "'Space Grotesk', sans-serif",
      '--heading-weight': '700',
      '--btn-bg': '#4ADE80',
      '--btn-fg': '#0B0E14',
      '--btn-weight': '500',
      '--btn-transform': 'none',
      '--btn-tracking': 'normal',
      '--card-shadow': 'none',
    },
    wordmark: { family: "'Space Grotesk', sans-serif", weight: 700, size: 20 },
  },
  podium: {
    tokens: {
      '--bg': '#FAF7F2',
      '--surface': '#FFFFFF',
      '--surface2': '#F5F1E9',
      '--border': '#E7E0D5',
      '--border2': '#D6CFC2',
      '--text': '#1C1917',
      '--muted': '#57534E',
      '--faint': '#A8A29E',
      '--accent': '#C2410C',
      '--ok': '#0F766E',
      '--run': '#B45309',
      '--bad': '#B91C1C',
      '--warn': '#B45309',
      '--ok-bg': '#E9F2F0',
      '--run-bg': '#F7EDDD',
      '--bad-bg': '#F6E7E7',
      '--warn-bg': '#F7EDDD',
      '--radius': '12px',
      '--radius-sm': '10px',
      '--btn-radius': '999px',
      '--font-body': "'Instrument Sans', sans-serif",
      '--font-mono': "'JetBrains Mono', monospace",
      '--font-heading': "'Instrument Serif', serif",
      '--heading-weight': '400',
      '--btn-bg': '#1C1917',
      '--btn-fg': '#FAF7F2',
      '--btn-weight': '600',
      '--btn-transform': 'none',
      '--btn-tracking': 'normal',
      '--card-shadow': '0 1px 2px rgba(28,25,23,.05)',
    },
    wordmark: { family: "'Instrument Serif', serif", weight: 400, size: 24 },
  },
  foundry: {
    tokens: {
      '--bg': '#141414',
      '--surface': '#1C1C1C',
      '--surface2': '#232323',
      '--border': '#2E2E2E',
      '--border2': '#3E3E3E',
      '--text': '#F5F5F4',
      '--muted': '#A3A3A3',
      '--faint': '#6E6E6E',
      '--accent': '#FACC15',
      '--ok': '#FACC15',
      '--run': '#FB923C',
      '--bad': '#EF4444',
      '--warn': '#FB923C',
      '--ok-bg': '#231F0E',
      '--run-bg': '#241A10',
      '--bad-bg': '#231111',
      '--warn-bg': '#241A10',
      '--radius': '6px',
      '--radius-sm': '4px',
      '--btn-radius': '4px',
      '--font-body': "'Archivo', sans-serif",
      '--font-mono': "'JetBrains Mono', monospace",
      '--font-heading': "'Archivo', sans-serif",
      '--heading-weight': '900',
      '--btn-bg': '#FACC15',
      '--btn-fg': '#141414',
      '--btn-weight': '800',
      '--btn-transform': 'uppercase',
      '--btn-tracking': '0.05em',
      '--card-shadow': 'none',
    },
    wordmark: {
      family: "'Archivo', sans-serif",
      weight: 900,
      size: 19,
      transform: 'uppercase',
      tracking: '0.03em',
    },
  },
};
